import { connect } from 'react-redux';
import { getSubmitStatus, getAllSimoPlans, getLoggedInUser } from 'reducers';
import { findSimoSub, simoImmediateRenewal } from 'actions/simoSubs';
import { fetchAllPlans } from 'actions/simoPlans';
import ImmediateRenewalModal from './ImmediateRenewalModal';

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'plan'),
  plans: getAllSimoPlans(state),
  loggedInUser: getLoggedInUser(state),
  isSimo: true,
});

const mapDispatchToProps = {
  immediateRenewal: simoImmediateRenewal,
  findSub: findSimoSub,
  fetchAllPlans,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ImmediateRenewalModal);
